import {
  ApprovalRule,
  Policy,
  RequestorRule,
  ResourceRule,
} from "@p0security/shared/types/policy/types";
import { Table } from "@p0security/ui";
import { nonNullable } from "@p0security/util/nonNullable";
import stringify from "json-stable-stringify";
import { useCallback } from "react";

import { NamePreview } from "../components/previews/NamePreview";
import { RequestorPreview } from "../components/previews/RequestorPreview";
import { ResourcePreview } from "../components/previews/ResourcePreview";
import { ApprovalSummary } from "./common";

type Props = {
  jsonRules: Policy[];
};

const SimpleTableView: React.FC<Props> = ({ jsonRules }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string | undefined) => <NamePreview name={name} />,
    },
    {
      title: "Resource",
      dataIndex: "resource",
      key: "resource",
      render: (resource: ResourceRule) => (
        <ResourcePreview resource={resource} />
      ),
    },
    {
      title: "Identity",
      dataIndex: "requestor",
      key: "requestor",
      render: (requestor: RequestorRule) => (
        <RequestorPreview requestor={requestor} />
      ),
    },
    {
      title: "Access",
      dataIndex: "approval",
      key: "approvalCombined",
      render: (approvals: ApprovalRule[]) => (
        <ApprovalSummary record={approvals} />
      ),
    },
  ];

  const stringifyRecord = useCallback(
    (record: Policy) => nonNullable(stringify(record)),
    []
  );

  return (
    <Table
      bordered
      columns={columns}
      dataSource={jsonRules}
      rowKey={stringifyRecord}
      pagination={false}
    />
  );
};

export default SimpleTableView;
